/**
 * @generated SignedSource<<1d7168f0efd49eb366e77e357467f1cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type plusWidgetWithoutAccess$data = {
  readonly highlightQueue: {
    readonly settings: unknown | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"plusWidgetDailyPulseQuery" | "plusWidgetHighlightsQuery" | "plusWidgetNewsAgendaQuery">;
  readonly " $fragmentType": "plusWidgetWithoutAccess";
};
export type plusWidgetWithoutAccess$key = {
  readonly " $data"?: plusWidgetWithoutAccess$data;
  readonly " $fragmentSpreads": FragmentRefs<"plusWidgetWithoutAccess">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dailyPulseTypeUuId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "highlightQueueName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaEndDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaStartDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaTypes"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "plusWidgetWithoutAccess",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "dailyPulseTypeUuId",
          "variableName": "dailyPulseTypeUuId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "plusWidgetDailyPulseQuery"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "queueName",
          "variableName": "highlightQueueName"
        }
      ],
      "kind": "FragmentSpread",
      "name": "plusWidgetHighlightsQuery"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "applicationId",
          "variableName": "applicationId"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaEndDate",
          "variableName": "plusNewsAgendaEndDate"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaStartDate",
          "variableName": "plusNewsAgendaStartDate"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaTypes",
          "variableName": "plusNewsAgendaTypes"
        }
      ],
      "kind": "FragmentSpread",
      "name": "plusWidgetNewsAgendaQuery"
    },
    {
      "alias": "highlightQueue",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "highlightQueueName"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "settings",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "56b52c1a22dd6b5e6b206d91d3e6a559";

export default node;
